import React, {useEffect, useRef} from 'react';

import {trackEvent} from 'analytics/Analytics';
import {LLM_CHAT_ANALYTICS_ACTIONS} from 'constants/analytics-products/LLMChatConstants';
import {AgentType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {ButtonSize} from 'ui-library/buttons/Button';
import APIUtil from 'util/APIUtil';

import StartChatInput from './StartChatInput';

export const ENTITY_ASK_ALLOWED_TABS = new Set([
  'metadata',
  'relevant-items-tab',
  'entity-results',
  'storage',
]);

interface EntityAskButtonProps {
  fileId: string;
}

export default function EntityAskButton({fileId}: EntityAskButtonProps): JSX.Element {
  const hasTrackedImpression = useRef(false);

  const modelType = APIUtil.apiIdToType(fileId);

  useEffect(() => {
    hasTrackedImpression.current = false;
  }, [fileId]);

  useEffect(() => {
    if (!hasTrackedImpression.current) {
      hasTrackedImpression.current = true;
      trackEvent(LLM_CHAT_ANALYTICS_ACTIONS.VIEWED_ENTITY_ASK_BUTTON, {
        itemId: fileId,
        modelType,
      });
    }
  }, [fileId, modelType]);

  return (
    <StartChatInput
      itemId={fileId}
      agentType={AgentType.ASK}
      buttonSize={ButtonSize.MINI}
      className="u-mini-spacing-right"
    />
  );
}
